module.exports = "/images/vendor/flag-icon-css/flags/1x1/sz.svg?dc2faeb7bafa9eca955d5788330ed384";